import transitionend from "../../util/transitionend";

function Menu(opt) {

    var options = {
            button: '.menu-button',
            nav: '.js.nav',
            button_container: '.header__right'
        },
        obj = {},
        body = document.querySelector('body');

    if (typeof opt === "object") {
        extendDefaults(options, opt);
    }

    init();

    function init() {
        obj.menuButton = document.querySelector(options.button);
        if (obj.menuButton !== null) {
            obj.nav = document.querySelector(options.nav);
            if (obj.nav !== null) {
                obj.nav.addEventListener('click', function(e) {
                    e.stopPropagation();
                });
                obj.menuButton.addEventListener('click', button__click);
            }
        }

        var openWPmenuButton = document.querySelector('.wp-block-navigation__responsive-container-open');
        var closeWPmenuButton = document.querySelector('.wp-block-navigation__responsive-container-close');
        if ( openWPmenuButton !== null && closeWPmenuButton !== null ) {
            var rect = openWPmenuButton.getBoundingClientRect();
            var topPosition = rect.top + window.scrollY;
            var leftPosition = rect.left + window.scrollX;

            closeWPmenuButton.style.top = topPosition + "px";
            closeWPmenuButton.style.left = leftPosition + "px";
        }
        
    }

    function button__click(e) {
        e.stopPropagation();
        obj.menuButton.classList.toggle('is-menu-open');
        obj.nav.classList.toggle('is-open');
        body.classList.toggle('is-menu-open');

        obj.nav.addEventListener(transitionend, function() {
            document.addEventListener('click', body__click);
        });
    }

    function body__click(e) {
        obj.menuButton.classList.remove('is-menu-open');
        obj.nav.classList.remove('is-open');
        body.classList.remove('is-menu-open');

        document.removeEventListener('click', body__click);
    }

    function extendDefaults(src, prop) {
        var property;
        for (property in prop) {
            if (prop.hasOwnProperty(property)) {
                src[property] = prop[property];
            }
        }
    }
}

export default Menu;



// WEBPACK FOOTER //
// ./js/components/menu/index.js